import { api } from "../api";

export default async function getUrl(provider: string): Promise<string> {
  try {
    const { data } = await api.get(`/auth/login/${provider}`);

    return data.authUrl as string;
  } catch (err) {
    console.log(err);

    return "";
  }
}
